// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Постанови» (Resolutions, ключ `resolution`, група `legislation`). */
export const resolutionsManifest: IModuleManifest = {
  key: 'resolution',
  group: 'legislation',
  slug: 'resolutions',
  prefix: 'RES',
  name: { en: 'Resolutions', uk: 'Постанови' },
  entities: [
    { key: 'resolution', slug: 'resolution', name: { en: 'Resolutions', uk: 'Постанови' }, main: true },
    { key: 'resolution_version', slug: 'resolution-version', name: { en: 'Resolution Versions', uk: 'Версії' }, main: false },
    { key: 'resolution_implementation_task', slug: 'resolution-implementation-task', name: { en: 'Resolution Implementation Tasks', uk: 'Завдання з виконання' }, main: false },
    { key: 'resolution_document', slug: 'resolution-document', name: { en: 'Resolution Documents', uk: 'Документи' }, main: false },
    { key: 'resolution_status', slug: 'resolution-status', name: { en: 'Resolution Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/resolutionsSlice').then((m) => m.resolutionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
